module.exports = __webpack_public_path__ + "img/terroir-wavy-1.707832ee.jpg";